import React from 'react';

type BadgeVariant = 'new' | 'confirmed' | 'preparing' | 'ready' | 'out-for-delivery' | 'delivered' | 'cancelled' | 'low-stock' | 'out-of-stock' | 'active' | 'inactive' | 'warning' | 'info' | 'positive';

interface BadgeProps {
  variant: BadgeVariant;
  label: string;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  new: 'bg-info-bg text-info',
  confirmed: 'bg-positive-bg text-positive',
  preparing: 'bg-warning-bg text-warning',
  ready: 'bg-[#EEF6FD] text-[#1A6FA8]',
  'out-for-delivery': 'bg-[#F0E8FF] text-[#6B35C7]',
  delivered: 'bg-positive-bg text-positive',
  cancelled: 'bg-negative-bg text-negative',
  'low-stock': 'bg-warning-bg text-warning',
  'out-of-stock': 'bg-negative-bg text-negative',
  active: 'bg-positive-bg text-positive',
  inactive: 'bg-muted text-muted-foreground',
  warning: 'bg-warning-bg text-warning',
  info: 'bg-info-bg text-info',
  positive: 'bg-positive-bg text-positive',
};

export default function Badge({ variant, label, className = '' }: BadgeProps) {
  return (
    <span className={`status-badge ${variantStyles[variant]} ${className}`}>
      {label}
    </span>
  );
}